export default __webpack_public_path__ + "static/media/img18.da3e066e.jpeg";